import styled from 'styled-components'

export const AlertContainer = styled.div`
	display: block;
	position: absolute;
	top: 90px;
	text-align: center;
`

export const PreviewContainer = styled.div`
	width: 100%;
	height: 100%;
`

export const LoaderContainer = styled.div`
	width: 100%;
	text-align: center;
	position: absolute;
	height: 100%;
	top: 0;
	left: 0;
	padding-top: 24px;
	background: #ffffffa8;
`

export const Container = styled.div`
	overflow-y: scroll;
	padding-top: 16px;
	padding-right: 46px;
	padding-left: 52px;
	align-self: center;
	display: flex;
	flex-direction: column;
	height: 100%;
`

export const ErrorMessage = styled.p`
	font-size: 16px;
	text-align: center;
	padding: 32px 24px;
`
